function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4 .667V2h-.667a.667.667 0 0 0-.662.589l-.004.078v2c0 .473-.165.908-.44 1.25L2.157 6l.07.082c.252.314.411.706.436 1.134l.004.117v2c0 .342.257.624.589.663l.077.004H4v1.333h-.667a2 2 0 0 1-1.996-1.882l-.004-.118v-2a.667.667 0 0 0-.589-.662l-.077-.004V5.333a.667.667 0 0 0 .662-.589l.004-.077v-2A2 2 0 0 1 3.216.67l.117-.003H4zm8.667 0l.117.003a2 2 0 0 1 1.883 1.997v2l.004.077c.039.332.32.59.662.59v1.333l-.077.004a.667.667 0 0 0-.59.662v2l-.003.118a2 2 0 0 1-1.996 1.882H12V10h.667l.077-.004a.667.667 0 0 0 .59-.663v-2l.003-.117a1.99 1.99 0 0 1 .436-1.134l.07-.082-.07-.082a1.992 1.992 0 0 1-.44-1.251v-2l-.004-.078A.667.667 0 0 0 12.667 2H12V.667h.667zM5 5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM8 5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z",
  fill: "#475059",
  fillRule: "evenodd"
});

var SvgIconCustomStates = function SvgIconCustomStates(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 12
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon_custom_states.8773512c.svg";
export { SvgIconCustomStates as ReactComponent };